import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import "./index.css";
import App from "./App.tsx";
import { AuthProvider } from "./contexts/auth/Provider.tsx";
import { ToastProvider } from "./contexts/toast/Provider.tsx";
import { ThemeProvider } from "./contexts/theme/ThemeProvider.tsx";
import { QueryClientProviderWithGlobalErrors } from "./query/QueryClientProviderWithGlobalErrors";
import { config } from "./config/config";
import ErrorFallback from "./components/ErrorFallback";
import { initQrScanBroadcaster } from "./utils/qrScanBroadcaster";

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.APP_ENV,
  enabled: !config.isDevelopment && Boolean(config.SENTRY_DSN),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (config.POSTHOG_TOKEN) {
  posthog.init(config.POSTHOG_TOKEN, {
    api_host: config.POSTHOG_HOST,
    person_profiles: "identified_only",
  });
}

initQrScanBroadcaster();

if (config.showEnvIndicator) {
  document.documentElement.classList.add("with-env-banner");
}

const tree = (
  <Sentry.ErrorBoundary fallback={ErrorFallback}>
    <StrictMode>
      <QueryClientProviderWithGlobalErrors>
        <AuthProvider>
          <ThemeProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProviderWithGlobalErrors>
    </StrictMode>
  </Sentry.ErrorBoundary>
);

createRoot(document.getElementById("root")!).render(
  config.POSTHOG_TOKEN ? (
    <PostHogProvider client={posthog}>{tree}</PostHogProvider>
  ) : (
    tree
  ),
);
